import { Skeleton } from '@/components/ui/skeleton'

export function KpiMetricsDashboardLoading() {
	return (
		<div className="flex flex-col gap-4">
			<div className="grid grid-cols-2 gap-3 sm:grid-cols-4">
				{['a', 'b', 'c', 'd'].map((key) => (
					<div
						key={key}
						className="rounded-lg border border-kaefer-light-silver bg-white p-4"
					>
						<Skeleton className="size-8 rounded-md" />
						<Skeleton className="mt-2 h-7 w-16" />
						<Skeleton className="mt-2 h-3.5 w-24" />
						<Skeleton className="mt-1 h-3 w-28" />
					</div>
				))}
			</div>
			<div className="grid grid-cols-1 gap-4 lg:grid-cols-2">
				{['a', 'b'].map((key) => (
					<div
						key={key}
						className="rounded-lg border border-kaefer-light-silver bg-white p-4"
					>
						<Skeleton className="h-4 w-40" />
						<Skeleton className="mx-auto mt-4 h-44 w-full" />
					</div>
				))}
			</div>
			<div className="rounded-lg border border-kaefer-light-silver bg-white p-4">
				<Skeleton className="h-4 w-56" />
				<Skeleton className="mt-4 h-64 w-full" />
			</div>
		</div>
	)
}
